import { Injectable, NgZone } from '@angular/core';
import { ConnectionErrorDialogComponent } from '../modules/shared/components/connection-error-dialog/connection-error-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class ConnectionMonitorService {
 private dialogRef: MatDialogRef<ConnectionErrorDialogComponent> | null = null;

  constructor(private dialog: MatDialog, private zone: NgZone) {
    
    this.init();
  }

  private init() {
    window.addEventListener('offline', () => this.zone.run(() => this.showDialog()));
    window.addEventListener('online', () => this.zone.run(() => this.closeDialog()));
  }

  private showDialog() {
    if (!this.dialogRef) {
      this.dialogRef = this.dialog.open(ConnectionErrorDialogComponent, {
        disableClose: true,
        panelClass: 'connection-error-dialog',
      });
    }
  }

  private closeDialog() {
    if (this.dialogRef) {
      this.dialogRef.close();
      this.dialogRef = null;
    }
  }
}
